import { Loader2 } from "lucide-react";
import { CaptureRow, useCaptures } from "@/components/conecta/CaptureRow";
import { useQueue } from "@/lib/captureQueue";

export default function RevisarPage() {
  const items = useCaptures({ review: true, limit: 100 });
  const queue = useQueue();
  return (
    <div data-testid="revisar-page" className="space-y-3">
      <p className="text-sm c-text-2">Capturas por confirmar, con dudas o con error. Cualquiera de los dos puede resolverlas.</p>
      {queue.length > 0 && <p data-testid="revisar-local-pending" className="text-xs c-muted">{queue.length} captura(s) aún en el teléfono, pendientes de subir.</p>}
      {!items ? <div className="py-12 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div> : (
        <div className="space-y-2.5" data-testid="revisar-list">
          {items.length === 0 && <p className="c-card p-6 text-sm c-text-2 text-center">Nada por revisar.</p>}
          {items.map((c) => <CaptureRow key={c.id} c={c} />)}
        </div>
      )}
    </div>
  );
}
